import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const LegalDocumentCard = ({ document }) => {
  return (
    <Link
      to={document?.path}
      className="group bg-card border border-border rounded-xl p-6 hover:shadow-lg hover:border-primary/50 transition-all duration-300"
    >
      <div className="flex items-start space-x-4">
        <div className={`w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
          <Icon name={document?.icon} size={24} className={document?.color} />
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="text-xl font-heading font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
            {document?.title}
          </h3>
          <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
            {document?.description}
          </p>

          <div className="flex items-center justify-between">
            <span className="text-xs text-muted-foreground">
              Last updated: {document?.lastUpdated}
            </span>
            <div className="flex items-center text-primary group-hover:translate-x-1 transition-transform">
              <span className="text-sm font-medium mr-1">Read More</span>
              <Icon name="ArrowRight" size={16} />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default LegalDocumentCard;